/**
 * Meldet den Abo-Start der Unternehmen mit eigener Abrechnung nach einer
 * Buchung im Organisations-Scope (Spec 2026-10-21): gestartete kurz
 * bestätigen, übersprungene mit Grund als Warnung. Ohne lesbaren Status
 * stehen statt der Namen die Nummern der Unternehmen.
 */
import type { OwnBillingOutcome } from '@/services/appsApi'
import {
  type CheckoutOutcomeMessages,
  checkoutOutcomeSnackbar,
  describeCheckoutOutcome,
  loadCompanyBillingStatuses,
} from '@/services/companyBilling'
import { useSnackbarStore } from '@/stores/snackbarStore'

export async function notifyCheckoutOutcome (outcome: Partial<OwnBillingOutcome>): Promise<CheckoutOutcomeMessages> {
  const hasStarted = (outcome.startedCompanies?.length ?? 0) > 0
  const hasSkipped = (outcome.skipped?.length ?? 0) > 0
  if (!hasStarted && !hasSkipped) {
    return { startedNames: [], skipped: [] }
  }
  const { statuses } = await loadCompanyBillingStatuses()
  const messages = describeCheckoutOutcome(outcome, statuses)
  const snack = checkoutOutcomeSnackbar(messages)
  if (snack) {
    useSnackbarStore().showSnackbar(snack)
  }
  return messages
}

export { type CheckoutOutcomeMessages } from '@/services/companyBilling'
